import styled from "@emotion/styled";
import {
  Alert,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RouterStyledLink } from "../../customStyles/StyledLinks";
import reqs from "../../data/requests";
import { ClientContextConsumer } from "./Client";
import { CustomModal } from "../../global_components/Modals";
import ResetPass from "../components/Login/ResetPass";
import { useEffect } from "react";

const StyledFormControle = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": {
    fontWeight: "500",
    opacity: 0.8,
  },
  marginRight: "30px",
});

const CLogin = () => {
  const [searchParams] = useSearchParams();
  const [rd, setRd] = useState(searchParams.get("rd") == 0 ? false : true);
  const [disabledInput, setDisabledInput] = useState(
    searchParams.get("di") == 1 ? true : false
  );
  const { triggerAv, setTriggerAv, clientProfile } = ClientContextConsumer();
  const [isPassModal, setIsPassModal] = useState(
    searchParams.get("pm") == 1 ? true : false
  );
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [clientLog, setClientLog] = useState({
    email: "",
    password: "",
  });
  const [mode, setMode] = useState("par");

  const ClientLogin = () => {
    axios
      .post(
        reqs[mode === "par" ? "PAR_LOGIN" : "CA_LOGIN"],
        { email: clientLog.email.trim(), password: clientLog.password, mode },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.succeed) {
          setError(false);
          setErrorMsg("");
          setClientLog({
            email: "",
            password: "",
          });
          setRd(true);
          setErrorMsg(res.data.msg);
          setTriggerAv(!triggerAv);
        } else {
          setError(true);
          setErrorMsg(res.data.msg);
        }
      })
      .catch((err) => {
        setError(true);
        setErrorMsg(err.response.data.msg);
      });
  };

  useEffect(() => {
    if (clientProfile.userName && rd === true) {
      navigate(`/profile/${clientProfile.userName}`);
    } else if (clientProfile.email && rd === false && disabledInput === true) {
      setClientLog((clientLog) => {
        return { ...clientLog, email: clientProfile.email };
      });
      setMode(clientProfile.mode);
    }
  }, [clientProfile]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clientLog.email && clientLog.password) {
      ClientLogin();
    } else {
      setError(true);
      setErrorMsg("Email or Password must not be empty");
    }
  };

  return (
    <div className="flex items-center justify-center mb-10 flex-col md:flex-row">
      <Container
        className="flex-1"
        maxWidth={"md"}
        sx={{ paddingTop: "15px", minHeight: "100vh" }}
      >
        <Stack
          alignItems={"center"}
          justifyContent={"center"}
          marginTop={"70px"}
          flexDirection={"column"}
        >
          <form
            onSubmit={handleSubmit}
            style={{
              maxWidth: "500px",
              width: "100%",
              margin: "0 auto",
            }}
          >
            <Stack
              borderRadius={"50px"}
              spacing={2}
              sx={{
                padding: "35px 40px 35px 40px",
                maxWidth: "400px",
                width: "100%",
                minHeight: "300px",
                height: "max-content",
                boxShadow: "0 0 10px 2px rgba(0,0,0,.2)",
                margin: "0 auto",
              }}
            >
              <h1 class="text-3xl font-semibold mb-3 text-black text-center font-mono">
                Log In
              </h1>
              <h1 class="text-sm font-semibold mb-6 text-gray-500 text-center Nunito">
                Join to Our Community with all time access
              </h1>

              {errorMsg && (
                <Alert severity={error ? "error" : "success"}>{errorMsg}</Alert>
              )}
              <Stack justifyContent={"center"} rowGap={3}>
                <TextField
                  error={error}
                  label="Email"
                  placeholder="Email Address"
                  type={"email"}
                  variant="standard"
                  sx={{
                    "& .Mui-disabled,& input:disabled": {
                      color: "rgba(0,0,0,.9)!important",
                    },
                  }}
                  value={clientLog.email}
                  disabled={disabledInput}
                  onChange={(e) =>
                    setClientLog((clientLog) => {
                      return { ...clientLog, email: e.target.value };
                    })
                  }
                  size="medium"
                />
                <TextField
                  error={error}
                  label="Password"
                  value={clientLog.password}
                  type={"password"}
                  placeholder="Pass Word"
                  variant="standard"
                  onChange={(e) =>
                    setClientLog((clientLog) => {
                      return { ...clientLog, password: e.target.value };
                    })
                  }
                />

                <FormControl>
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ fontWeight: 500, ml: 0.5, marginBottom: "5px" }}
                  >
                    Login as :
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="mode-change-radio"
                    defaultValue={"par"}
                    name="mode-change-radio"
                    row
                    sx={{ margin: "0 auto" }}
                    value={mode}
                  >
                    <StyledFormControle
                      value="par"
                      control={<Radio />}
                      label="Participant"
                      onChange={(e) => setMode(e.target.value)}
                    />
                    <StyledFormControle
                      value="ca"
                      control={<Radio />}
                      label="CA"
                      onChange={(e) => setMode(e.target.value)}
                    />
                  </RadioGroup>
                </FormControl>
              </Stack>

              <Stack pt={1}>
                <button
                  type="submit"
                  class="w-full bg-black text-white p-2 rounded-md hover:bg-gray-800 focus:outline-none focus:bg-black focus:ring-2 focus:ring-offset-2 focus:ring-gray-900 transition-colors duration-300"
                >
                  Sign Up
                </button>
                <div class="mt-4 text-sm text-gray-600 text-center">
                  <p>
                    Don't have an account?{" "}
                    <a
                      href="/registration/participant"
                      class="text-black hover:underline"
                    >
                      SignUp here
                    </a>
                  </p>
                </div>
              </Stack>
            </Stack>
          </form>
        </Stack>

        <Typography
          align="center"
          mt={1.5}
          sx={{
            color: "#A020F0",
            fontWeight: 500,
            letterSpacing: ".7px",
            cursor: "pointer",
            transition: ".3s ease all",
            "&:hover": {
              color: "purple",
            },
          }}
          color={"warning.dark"}
          onClick={() => {
            setIsPassModal(true);
          }}
        >
          Forgot password ?
        </Typography>
        {/* reset pass modal */}
        <CustomModal open={isPassModal} setOpen={setIsPassModal}>
          <ResetPass
            setModalOpen={setIsPassModal}
            clientLog={clientLog}
            setClientLog={setClientLog}
            mode={mode}
            setMode={setMode}
            modalOpen={isPassModal}
            clientProfile={clientProfile}
            rd={rd}
            disabledInput={disabledInput}
          />
        </CustomModal>
      </Container>
      <img
        src="/Images/banners/about.jpg"
        alt="Banner"
        className="w-[50%] object-contain md:mr-10 rounded-3xl"
      />
    </div>
  );
};

export default CLogin;
